module.exports = __webpack_public_path__ + "img/money-bag-report.637c25db.png";